import { useMemo, type ReactNode } from "react";
import { buildAbilityFromLegacy } from "@yalana/contracts";
import type { AuthContextValue } from "./auth-helpers";
import { AuthContext, useAuth } from "./auth-context";

export function useAbility() {
  return useAuth().ability;
}

const STUB_AUTH_DEFAULTS: AuthContextValue = {
  user: null,
  ability: buildAbilityFromLegacy([], false),
  authorizedTenants: [],
  loading: false,
  signInWithPassword: async () => ({}) as never,
  signInWithOtp: async () => {},
  signUpWithMagicLink: async () => {},
  signOut: async () => {},
};

/** Provides a stub AuthContext value — for Storybook and unit tests only. */
export function StubAuthProvider({
  children,
  value = {},
}: {
  children: ReactNode;
  value?: Partial<AuthContextValue>;
}) {
  const stub = useMemo(() => ({ ...STUB_AUTH_DEFAULTS, ...value }), [value]);
  return <AuthContext.Provider value={stub}>{children}</AuthContext.Provider>;
}
